import {UI} from "../../../stem-core/ui/UIBase";
import {StyleSheet} from "../../../stem-core/ui/Style";
import {merchantStyleRule} from "../Security";
import {isSmallScreen} from "../../UtilsLib";
import {iFrameState} from "../../services/IFrameState";
import {GATE_TYPE} from "../../../blink-sdk/Constants";
import {isString} from "../../../stem-core/base/Utils";
import {registerStyle} from "../../../stem-core/ui/style/Theme";
import {MessageElement} from "../../widget/ui/MessageElement";


// TODO @cleanup remove this crap
class PanelTextStyle extends StyleSheet {
    @merchantStyleRule
    container = {
        color: this.themeProps.TEXT_SECONDARY_COLOR,
        width: "100%",
        margin: "18px 0px",
        fontSize: this.themeProps.FONT_SIZE_LARGE,
        textAlign: () => (isSmallScreen() || iFrameState.gateType === GATE_TYPE.banner) ? "left" : "center",
        ...iFrameState.textStyle,
    };
}

@registerStyle(PanelTextStyle)
export class PanelText extends UI.Element {
    setOptions(options) {
        if (Array.isArray(options.children) && !options.children.length) {
            // TODO @cleanup shit is here
            options.children = iFrameState.iframeParams.text || [];
        }
        if (Array.isArray(options.children) && options.children.length === 1) {
            options.children = options.children[0];
        }
        if (isString(options.children) || options.children instanceof UI.TextElement) {
            options.children = options.children.toString().split("\n").map(line => <div style={{minHeight: "1em"}}>
                <MessageElement message={line} />
            </div>);
        }
        return super.setOptions(options);
    }
}
